module.exports = __webpack_public_path__ + "static/media/imgPark_Card3AsesoramientoBig_PC.5d55d9c3.png";